<svelte:head>
  <script src="argon2-browser/lib/argon2.js" on:load={argon2DidLoad}></script>
</svelte:head>

<script>
	export let appname;

	import Modal from './Modal.svelte'
	import nacl from 'tweetnacl'
	import {patterns, pattern_bits_of_security, bytes_to_pwd, entropy, buf2hex} from './pwdutil.js'
	import {passy_passy1} from './passy1.js' // legacy

	let blacklist = []
	fetch('blacklist.txt')
		.then(response=>response.text())
		.then(data=>blacklist=data.split('\n'))

	let mp_salt = '986da168e3e77b4374f6ba92750b9a1e3b6bdb86597d56f43d3627d65f2b8971'
	let mp_verify_salt = '9d1ab3a611a8a97487a500e4290ce0ab7a585505f40680e361266c857c681e8b'
	let gp_salt = 'a88292ec5b3c9ceb7f5aa3a7cefaf9a03a476604002d092439fefdf188ed0a75'

	let timeout = [null, null]

	function async_hash(pass, salt, cb, tout_num){
		clearTimeout(timeout[tout_num])
		timeout[tout_num] = setTimeout(() => {
			argon2.hash({
				pass:pass, 
				salt:salt,
				hashLen: 32,
				time: 1,
				mem:32*1024,
				parallelism:4,
				type: argon2.ArgonType.Argon2di
			}).then(cb).then(()=>timeout[tout_num] = null)			
		}, 1000);
	}


	let argon2_loaded = false
	async function argon2DidLoad(){
		argon2_loaded = true
		window.argon2WasmPath = 'argon2-browser/dist/argon2.wasm'
	}

	let did_enter_mp = false
	var enc = new TextEncoder();
	let mp 
	let mp_hash = '00'
	let gp = '00'
	let tag
	let variant = 'passy2'
	let old_variant

	let legacy_mode = false
	function changed_legacy_mode(){
		if (legacy_mode){
			old_variant = variant
			variant = 'passy1'
		}else{
			variant = old_variant
		}
	}

	$: mpe = entropy(mp)
	$: sectextcolor = mpe < 1 ? 'lightgrey' : (mpe < 50 ? 'red' : (mpe < 70 ? 'orange' : 'green'))

	$: (mp && argon2_loaded) ? async_hash(mp, mp_salt, h => mp_hash=h.hash, 0) : mp_hash = '00'
	//$: mp_hash = multihash(mp, 10000)

	
	$: (mp_hash && argon2_loaded) ? async_hash(Uint8Array.from([...enc.encode(variant), ...mp_hash, ...nacl.hash(enc.encode(tag))]), gp_salt, h => gp = h.hash, 1) : gp = '00'
	//$: gp = multihash(mp_hash + tag, 10000)

	$: genpass = (legacy_mode ? passy_passy1(mp, tag) :  bytes_to_pwd(gp, patterns[variant]))

	let show_blacklist_popup = false
	function on_input_mp(e){
		//console.log('on_input_mp',e)
		if (e.keyCode==13){
			if (blacklist.includes(mp)){
				show_blacklist_popup = true
			}else{
				did_enter_mp = true
			}
			
		}
		
		
		//document.getElementById("tag-input").focus()
	}
	
	function on_focus_mp(){
		did_enter_mp = false
	}
	function focustag(e){
		e.focus()
	}
	function on_input_tag(){

	}
	function copyToClipboard(el) {
		var oldContentEditable = el.contentEditable,
			oldReadOnly = el.readOnly,
			range = document.createRange();

		el.contentEditable = true;
		el.readOnly = false;
		range.selectNodeContents(el);

		var s = window.getSelection();
		s.removeAllRanges();
		s.addRange(range);

		el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

		el.contentEditable = oldContentEditable;
		el.readOnly = oldReadOnly;

		document.execCommand('copy');
	}

	let mp_entry_field
	let passwordfield
	function copy_password(){
		copyToClipboard(passwordfield)
	}

</script>

<main>
	<h1>{appname}</h1>
	{#if argon2_loaded}
	<div>
		<span><input 
			type="password" 
			placeholder="Master Password" 
			on:keypress={on_input_mp}
			bind:this={mp_entry_field}
			on:focus={on_focus_mp}
			bind:value={mp}
			></span>
		<span style="color:{sectextcolor}">Est. Security &lt; {mpe.toFixed(1)} BoS</span>
	</div>
	{/if}
	{#if did_enter_mp && timeout[0] === null}
		<div>
			<span>
				<input 
					id="tag-input" 
					type="text" 
					placeholder="Tag"
					use:focustag
					on:input = {on_input_tag}
					bind:value={tag}
					>
			</span>
		</div>
		<div>
			<span>
				<input disabled={timeout[1] !== null} type=text value={genpass} readonly style="width:320px" bind:this={passwordfield}>
			</span>
			<span><button on:click={copy_password}>Copy</button></span>
		</div>
		<div>
			<!--<span>
				<select bind:value={variant} disabled={legacy_mode}>
					{#each Object.entries(patterns) as pat}
						<option value={pat[0]}>
							{pat[0]} (BoS={pattern_bits_of_security(pat[1]).toFixed(1)}) 
						</option>
					{/each}
				</select>
			</span>-->
			<span style="font-size:9px">
				<label>Legacy Mode <input type="checkbox" bind:checked={legacy_mode} on:change={changed_legacy_mode}></label>
			</span>
		</div>
	{/if}
	{#if show_blacklist_popup}
		<Modal on:close="{() => show_blacklist_popup = false}">
			<h2 slot="header">
				Insecure Password
			</h2>

			<p>
				Your chosen master password <code>{mp}</code> has been found in 
				a blacklist of 100.000 most frequent passwords. 
				Those are among the first hackers 
				gonna try. You definitely want to avoid them. Thus,
				for security reasons, <em>PASSY</em> will not allow you to use this password.
				Pick a more secure one.
			</p>

			<a href="https://www.nist.gov/publications/digital-identity-guidelines-authentication-and-lifecycle-management">Guidelines you may want to follow.</a>
		</Modal>
{/if}

</main>

<style>
	main {
		text-align: center;
		/*padding: 1em;*/
		min-width: 360px;
		max-width: 640px;
		margin: 0 auto;
	}

	h1 {
		color: #0077ff;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

</style>

